// extracted by mini-css-extract-plugin
export default {"facetCarouselContainer":"IWMlj","navigation":"Tu2Ty"};